require('./ui-grid');
module.exports = 'ui.grid';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-grid/index.js
// module id = 16
// module chunks = 0